










import {Vue, Component, Prop, Inject} from 'vue-property-decorator';
import {showConfirm, showSuccess, showWarning} from "@/utils/UI";
import {API_BIS_PATENT_BATCHCATEGORY} from "@/configs/Apis";
import {isEmptyOrWhiteSpace} from "@/utils/Common";

@Component
export default class BatchCategory extends Vue {
    @Prop({type: Boolean, default: () => false})
    visible!: boolean;

    @Prop({type: Array, default: () => [], required: true})
    patentIdList!: Array<string>;

    @Prop({type: String, default: () => ""})
    treeData!: string;

    staticTreeData: Array<any> = [];

    @Inject()
    projectId!: string;

    changed: boolean = false;

    created() {
        if (!isEmptyOrWhiteSpace(this.treeData)) {
            this.staticTreeData = JSON.parse(this.treeData);
            this.staticTreeData.forEach(item => item.disabled = true);
        }
    }

    closeDialog() {
        this.$emit("update:visible", false);
        if (this.changed) {
            this.$emit("data-changed");
        }
    }

    doCategory() {
        if (!this.patentIdList || !this.patentIdList.length) {
            showWarning("请选择专利数据");
            return;
        }
        const tree = this.$refs.tree as any;
        const selectedNodes = tree.getCheckedNodes();
        if (!selectedNodes || !selectedNodes.length) {
            showWarning("请选择一个分类");
            return;
        }
        showConfirm("是否批量分类").then(() => {
            const postedData: Array<Array<string>> = [];
            postedData.push(...selectedNodes.map((node: any) => node.id));
            this.$http.post({url: API_BIS_PATENT_BATCHCATEGORY, path: {projectId: this.projectId}}, {patentIdList: this.patentIdList, categoryIdList: postedData}).then(() => {
                showSuccess("分类成功");
                this.changed = true;
                this.closeDialog();
            });
        });
    }
}

